import { DEBUG, KEYCLOAK_ACCOUNT_URI, RESTRICTED_MAIL_DOMAINS } from "./config";
import { DomHelper } from "./domHelper";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { Util } from "./util";
export function publicRouter(url) {
    if (DEBUG)
        console.log("-->publicRouter called", url);
    const params = new URLSearchParams(url.search);
    const action = params.get('action');
    if (DEBUG)
        console.log("action", action);
    DomHelper.disableDefaultLogin();
    DomHelper.disableDefaultNavigation();
    switch (action) {
        case 'register':
            renderRegisterForm(params);
            break;
        case 'cmdb':
            renderCMDBForm();
            break;
        default:
            renderDefault();
    }
}
function renderRegisterForm(params) {
    if (DEBUG)
        console.log("-->renderRegisterForm");
    DomHelper.setHeaderTitle("open-diakonie.de", "Registrierung");
    const id = params.get('id');
    if (DEBUG)
        console.log("id", id);
    if (!id)
        return;
    getBackendData("", `/public/invitation/${Util.urlEncode(id)}`, "GET", "application/json", "", function (response) {
        const responseData = JSON.parse(response.target.response);
        console.log("invitation", responseData);
        renderRegisterInputForm(responseData[0]);
    });
}
function renderRegisterInputForm(invitation) {
    const appNode = document.querySelector('main');
    if (appNode) {
        DomHelper.appendNode(appNode, 'h1', [], [], "Sie wurden eingeladen einen Account zu erstellen.");
        DomHelper.appendNode(appNode, 'p', [], [], "Bitte ergänzen Sie Ihre Daten und klicken Sie auf 'Registrieren'.");
        const formNode = DomHelper.appendNode(appNode, "form", ['not-disabled'], [{ attr: "id", value: "rudi-profile-form" },
            { attr: "rudi-username", value: invitation.username + "" }
        ]);
        const givenName = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'givenName', 'Vorname', "", [], false);
        const surName = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'sn', 'Nachname', "", [], false);
        const mail = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'mail', 'E-Mail-Adresse', invitation.mail, [], invitation.mail != undefined && invitation.mail != "");
        const phone = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'phone', 'Mobil Nummer', invitation.phone, [], invitation.phone != undefined);
        const password1 = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'password1', 'Passwort', "", [], false, undefined, false, 'password');
        const password2 = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'password2', 'Passwort bestätigen', "", [], false, undefined, false, 'password');
        const sectionButton = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
        DomHelper.appendNode(sectionButton, 'button', ['btn', 'btn-primary', 'mt-2'], [{
                attr: "type",
                value: "submit"
            }], "Registrieren");
        sectionButton.addEventListener("click", function (event) {
            let data = {
                givenName: givenName.value,
                sn: surName.value,
                mail: mail.value,
                mobile: phone.value,
                password: password1.value
            };
            event.preventDefault();
            DomHelper.resetFormInvalidMessages(formNode);
            let isValid = true;
            try {
                validateRegisterMail(mail.value);
            }
            catch (e) {
                isValid = false;
                const message = e.message;
                DomHelper.addInvalidMessage(formNode, mail, message);
            }
            if (givenName.value == "") {
                isValid = false;
                DomHelper.addInvalidMessage(formNode, givenName, "Der Vorname darf nicht leer sein.");
            }
            if (surName.value == "") {
                isValid = false;
                DomHelper.addInvalidMessage(formNode, surName, "Der Nachname darf nicht leer sein.");
            }
            if (password1.value === "") {
                isValid = false;
                DomHelper.addInvalidMessage(formNode, password1, "Das Passwort darf nicht leer sein.");
            }
            if (password2.value === "") {
                isValid = false;
                DomHelper.addInvalidMessage(formNode, password2, "Bitte bestätigen Sie Ihr Passwort.");
            }
            if (password1.value !== password2.value) {
                isValid = false;
                DomHelper.addInvalidMessage(formNode, password2, "Die Passwörter stimmen nicht überein.");
            }
            event.preventDefault();
            if (isValid) {
                sendBackendData('', `/public/invitation/${invitation.id}`, "POST", 'application/json', "", data, (response) => {
                    console.log("response", response);
                });
            }
        });
    }
}
function isDomainAvailable(mail) {
    return !RESTRICTED_MAIL_DOMAINS.some(domain => mail.endsWith(`@${domain}`));
}
function validateRegisterMail(mail) {
    if (!isDomainAvailable(mail))
        throw new Error(`Für diese Mailadresse ist keine Selbstregistrierung möglich.<br> In der Regel besteht ihr Account bereits. Bitte versuchen Sie es über den Weg <a href=${KEYCLOAK_ACCOUNT_URI}>Passwort vergessen.</a> `);
    return true;
}
function renderCMDBForm() {
    if (DEBUG)
        console.log("-->renderCMDBForm");
    DomHelper.setHeaderTitle("open-diakonie.de", "CMDB");
}
function renderDefault() {
    if (DEBUG)
        console.log("renderDefault");
}
